import { useGregorFlagsReady } from 'mednet-cns/src/hooks/gregor'
import {
  useQuestionSearchAlgorithm,
  useEnforceAlgoliaQuestionSearchInAutoComplete,
} from 'mednet-cns/src/hooks/gregorFlags'

export default function useNewSearchExperienceFlag() {
  const isLdReady = useGregorFlagsReady()

  const questionSearchAlgorithm = useQuestionSearchAlgorithm()
  const enforceAlgoliaQuestionSearchInAutoComplete =
    useEnforceAlgoliaQuestionSearchInAutoComplete()

  const enableNewSearchExperience =
    !enforceAlgoliaQuestionSearchInAutoComplete &&
    questionSearchAlgorithm === 'lux_and_llm'

  return {
    enableNewSearchExperience,
    isLdReady,
  }
}
